<template>
  <span :class="$style.chip">
    {{ text }}
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'OutlineChip',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
})
</script>

<style lang="scss" module>
.chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.2em 1em 0.22em;
  border: 1px solid currentcolor;
  background-color: $color-surface-primary;
  border-radius: 999em;
  color: $color-text-and-object-accent-primary;
  font-size: 10px;
  font-weight: bold;
  line-height: 1.3em;
}
</style>
